/**
 * Utility functions for checking user permissions
 */

/**
 * Get the current user type from localStorage
 * @returns {string} User type (Admin, President, User, etc.)
 */
export const getUserType = () => {
  try {
    return localStorage.getItem('userType') || 'User';
  } catch (error) {
    return 'User';
  }
};

/**
 * Check if the current user is an Admin
 * @returns {boolean}
 */
export const isAdmin = () => {
  return getUserType() === 'Admin';
};

/**
 * Check if the current user is a President
 * @returns {boolean}
 */
export const isPresident = () => {
  return getUserType() === 'President';
};

/**
 * Check if the current user has view-only permissions (President role)
 * @returns {boolean}
 */
export const isViewOnly = () => {
  return isPresident();
};

/**
 * Check if the current user can perform actions (not view-only)
 * @returns {boolean}
 */
export const canPerformActions = () => {
  return !isViewOnly();
};

/**
 * User may only see male students (from localStorage, set at login).
 * @returns {boolean}
 */
export const canViewOnlyMale = () => {
  try {
    return localStorage.getItem('viewOnlyMaleData') === 'true';
  } catch (error) {
    return false;
  }
};

/**
 * User may only see female students (from localStorage, set at login).
 * @returns {boolean}
 */
export const canViewOnlyFemale = () => {
  try {
    return localStorage.getItem('viewOnlyFemaleData') === 'true';
  } catch (error) {
    return false;
  }
};

/**
 * If restricted by user permissions, returns 'Male' or 'Female'; otherwise null (no filter).
 * @returns {'Male' | 'Female' | null}
 */
export const getGenderFilter = () => {
  if (canViewOnlyMale()) return 'Male';
  if (canViewOnlyFemale()) return 'Female';
  return null;
};

